import React, { 
    useState,
    useEffect 
} from "react";
import { Routes, Route, useParams, useLocation } from "react-router-dom";

import config from "./config/config";

console.log("Booking config:", config);

// Components
import { ProtectedRoute } from "./protected-route";
import { PushNotification } from './components/push-notification';
import BookOnline from "./book-online/book-online";
import SelectSeats from "./book-online/select-seats";
import TicketDonations from "./ticket-donations/ticket-donations";
import Extras from "./extras/extras";
import IframeBasket from "./basket/iframe-basket";
import Basket from "./basket/basket";
import Login from "./login/login";
import Checkout from "./checkout/checkout";
import CreateAccount from "./account/create-account";
import OrderConfirmation from "./order-confirmation/order-confirmation";
import Account from './account/account';
import AccountOrders from './account/account-orders';
import AccountTickets from "./account/account-tickets";
import AccountMemberships from './account/account-memberships';
import AccountHelp from './account/account-help';
import AccountPreferences from './account/account-preferences';
import AccountDetails from './account/account-details';
import AccountPayments from './account/account-payments';
import PasswordReset from "./account/reset-password";
import RedeemGift from "./account/redeem-gift";
import IframeAccount from "./account/iframe-account";
import Breadcrumbs from "./components/breadcrumbs";
import IframeGiftVouchers from "./gift-vouchers/iframe-gift-vouchers";

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "auto" });
    }, [pathname]);

    return null;
}

export default function Router() {
    const [checkedForQueue, setCheckedForQueue] = useState(false);
    const [checkedForPriority, setCheckedForPriority] = useState(false);

    const { pathname } = useLocation()

    const instance_continue_link = (direction = '') => {
        const instanceId = pathname.split("/")[2];
        const hasDonationPage = config.ATTRIBUTES?.DonationUpsellCampaignName && config.OPTION_FIELDS.donation_campaign?.some(donation => donation.spektrix_attribute_name === config.ATTRIBUTES?.DonationUpsellCampaignName)
        

        if ((direction == '/ticket-donations' && hasDonationPage) || (direction == '/extras' && config.SUPPLEMENTARY_INSTANCES?.length)) {
            return `/book-online/${instanceId}${direction}`
        } 

        if(hasDonationPage && !direction) {
            return `/book-online/${instanceId}/ticket-donations`
        }

        if((config.SUPPLEMENTARY_INSTANCES?.length && !direction) ||
            ((direction == '/ticket-donations' && !hasDonationPage) && config.SUPPLEMENTARY_INSTANCES?.length)) {
            return `/book-online/${instanceId}/extras`
        }

        return "/basket";
    };

    return (
        <>
            <ScrollToTop />
            { !['my-account', 'login'].includes(pathname.split("/")[1]) && <Breadcrumbs/>}
            <Routes>
                {/* Event routes */}
                <Route path="book-online/:instanceId?" element={<BookOnline continueLink={instance_continue_link()} checkedForQueue={checkedForQueue} setCheckedForQueue={setCheckedForQueue} checkedForPriority={checkedForPriority} setCheckedForPriority={setCheckedForPriority} />} />
                <Route path="book-online/:instanceId?/select-seats" element={<SelectSeats continueLink={instance_continue_link('/ticket-donations')} checkedForQueue={checkedForQueue} setCheckedForQueue={setCheckedForQueue} checkedForPriority={checkedForPriority} setCheckedForPriority={setCheckedForPriority} />} />
                
                {config.OPTION_FIELDS.donation_campaign?.length && config.ATTRIBUTES?.DonationUpsellCampaignName &&
                  <Route path="book-online/:instanceId?/ticket-donations" element={<TicketDonations  continueLink={instance_continue_link('/extras')} />} />
                }

                {config.SUPPLEMENTARY_INSTANCES?.length && 
                    <Route path="book-online/:instanceId?/extras" element={<Extras />} />
                }

                {/* Basket/checkout routes */}
                {config.OPTION_FIELDS.use_iframe_basket ? (
                    <Route path="basket" element={<IframeBasket />} />
                ) : (
                    <Route path="basket" element={<Basket />} />
                )}
                
                <Route path="checkout" element={<Checkout setCheckedForPriority={setCheckedForPriority} checkedForPriority={checkedForPriority} />} />
                <Route path="order-confirmation" element={<ProtectedRoute><OrderConfirmation /></ProtectedRoute>} />

                <Route path="your-visit/gift-vouchers" element={<IframeGiftVouchers />} />

                {/* Account routes */}
                {config.USE_IFRAME_ACCOUNT ? (
                <>
                    <Route path="login" element={<IframeAccount />} />
                    <Route path="my-account" element={<IframeAccount />} />
                </>
                ) : (
                <>
                    <Route path="login" element={<Login />} />
                    <Route path="create-account" element={<CreateAccount />} />
                    <Route path="account/password-reset" element={<PasswordReset />} />
                    <Route path="account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
                    <Route path="account/orders" element={<ProtectedRoute><AccountOrders /></ProtectedRoute>} />
                    <Route path="account/orders/tickets/:instanceId?" element={<ProtectedRoute><AccountTickets /></ProtectedRoute>} />
                    <Route path="account/memberships" element={<ProtectedRoute><AccountMemberships /></ProtectedRoute>} />
                    <Route path="account/help" element={<ProtectedRoute><AccountHelp /></ProtectedRoute>} />
                    <Route path="account/preferences" element={<ProtectedRoute><AccountPreferences /></ProtectedRoute>} />
                    <Route path="account/details" element={<ProtectedRoute><AccountDetails /></ProtectedRoute>} />
                    <Route path="account/payments" element={<ProtectedRoute><AccountPayments /></ProtectedRoute>} />
                    <Route path="account/redeem-gift" element={<ProtectedRoute><RedeemGift /></ProtectedRoute>} />
                </>
                )}
            </Routes>

            <PushNotification />
        </>
    );
}
